import React from 'react';
import { GridTypeMap, Grid as MuiGrid } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { GridProps } from './model';
export type { GridProps } from './model';

export const Grid = React.forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  return <MuiGrid {...props} ref={ref} />;
}) as OverridableComponent<GridTypeMap>;
